import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  type = "article", // 'article' | 'user'
  ...props
}) {

  const fallbackSrc = "/assets/images/article_no_img.png";

  const imgSrc = src || fallbackSrc;

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = fallbackSrc;
      }}
      {...props}
    />
  );
}

export default Image;
